const SVG_CLASS_NAME = {
    check: 'fa-check fa-w-16 has-text-success',
    pen: 'fa-pen fa-w-16 has-text-danger',
    lock: 'fa-lock fa-w-14 has-text-success',
    search: 'fa-search fa-flip-horizontal fa-w-16 has-text-danger',
};

export default SVG_CLASS_NAME;